import { Component, Host, Prop, State, h } from '@stencil/core';
import { Unsubscribe } from 'redux';
import { Language, SourceName } from '../../enums/const-enums';
import { logd } from '../../utils/utils';

interface OstNotification {
  id: number;
  name: string;
  level: 'WARNING' | 'ERROR' | 'INFO';
  locations: string[];
  content: {
    text: string;
    title: string;
    language: 'NL' | 'EN';
  };
}

@Component({
  tag: 'rass-ost',
  shadow: true,
})
export class RassOnlineStatusTool {
  @Prop() assetsPath: string;
  @Prop() language: Language;
  @Prop() sourceName: SourceName;
  @State() notifications: OstNotification[] = [];
  unsubscribe!: Unsubscribe;

  // OST API Settings
  url =
    location.hostname === 'localhost'
      ? `${location.origin}/api/msp/messages`
      : 'https://status.rabobank.nl/api/messages';
  appName = 'DESKTOP';
  location = 'LOGON_PAGE';

  async componentDidLoad(): Promise<void> {
    if (this.isAllowedContext) {
      await this.getOstNotifications();
    }
  }

  get isAllowedContext(): boolean {
    try {
      return (
        this.sourceName === SourceName.LOGIN && // Login screen only
        !document.cookie.includes('PNP=') && // Not in the native shell
        window === top // Not in iframes
      );
    } catch {
      return false;
    }
  }

  async getOstNotifications(): Promise<void> {
    try {
      const ostURL = new URL(this.url);
      ostURL.searchParams.append('app', this.appName);
      ostURL.searchParams.append('location', this.location);
      const ostHeaders = new Headers();
      ostHeaders.append('Accept-Language', this.language);
      const response = await fetch(ostURL, {
        headers: ostHeaders,
      });
      if (response.ok) {
        // Fetch doesnt reject on 4xx or 5xx status codes so we need to check for ok to be true
        this.notifications = (await response.json()) as OstNotification[];
      } else {
        throw new Error(`Status: ${response.status}`); // Send other status codes to the catch block
      }
    } catch (error) {
      logd(() =>
        console.error('Failed getting OST notifications due to:', error),
      );
    }
  }

  render(): void {
    return (
      <Host>
        <style>@import url({`'${this.assetsPath}css/sfc-style.css'`});</style>
        {this.notifications.map((notification, index) => {
          return (
            <sfc-notification
              type={
                notification.level.toLowerCase() as Lowercase<
                  OstNotification['level']
                >
              }
              header={notification.content.title}
              key={index}
            >
              {notification.content.text}
            </sfc-notification>
          ) as void;
        })}
      </Host>
    ) as void;
  }
}
